import React from 'react';
import styles from './TabLabelIcon.module.scss';

type TabLabelIconProps = {
  extraClass?: string;
  isProvidedField?: boolean;
  customIcon?: {
    name: string;
    tooltip?: string;
  };
};

const defaultIcon = 'icon-information';

const TabLabelIcon: React.FC<TabLabelIconProps> = ({ extraClass = '', isProvidedField = false, customIcon }) => (
  <i
    className={`di ${customIcon?.name || defaultIcon} ${styles.TabLabelIcon} ${isProvidedField ? styles.ProvidedField : ''} ${extraClass}`}
    title={customIcon?.tooltip || undefined}
  />
);

export default TabLabelIcon;
